import {
  SAVE_BRAND_YARAGH_LIST,
  SAVE_BAZSHO_LIST,
  SAVE_HALAT_LIST,
  SAVE_ARSHIV_BRAND_DATA,
  SAVE_YARAGH_COUNTRY,
  SAVE_MAHDOODE_DATA,
  SAVE_MAHDOODEFANI_DATA,
  ACTION_GET_BRAND_YARAGH_RELATION,
  ACTION_GET_BAZSHO_YARAGH_RELATION,
  SELECT_BAZSHO,
  MAHDOODE_SEARCH,
  SEARCHBRANDFITTING,
  SEARCHPOP,
  SAVENEWSTUFF,
  SAVENEWSTUFF_ROK,
} from "Stores/actionTypes";
import YaraghService from "../../../Services/http/endpoints/properties/YaraghService";
import { read } from "../../../Helpers/LocalStorage";
import StatusHandler from "../../../Helpers/StatusHandler";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getAllYaragh = (params, index = -1) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getAllYaragh(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const brandYaraghList = response.data.Value;
        const updateBrandYaraghList = brandYaraghList.map((item) => {
          return {
            ...item,
            label: item.Name,
            value: item.Id,
          };
        });
        dispatch({
          type: SAVE_BRAND_YARAGH_LIST,
          brandYaraghList: updateBrandYaraghList,
          selectedBrandYaragh: index === -1 ? brandYaraghList.length > 0 ? brandYaraghList[0] : null : brandYaraghList[index],
        });
        // if(brandYaraghList.length>0) {
        //   dispatch({
        //     type: SELECT_BRAND_YARAGH,
        //     selectedBrandYaragh: brandYaraghList[0],
        //   });
        // }
        return brandYaraghList;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllBrandYaragh = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getAllBrandYaragh(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const updateValue = response.data.Value.map((data, index) => {
          return {
            ...data,
            num: index,
            Keshvar: data.IdCountry,
            Struct: data.Struct === "U" ? "upvc" : "alu",
          };
        });
        dispatch({
          type: SAVE_ARSHIV_BRAND_DATA,
          arshivBrandData: updateValue,
          arshivBrandDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const setNameForSearchBrandYaragh = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SEARCHBRANDFITTING,
      data
    });
  };
};

export const getAllYaraghCountry = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getAllYaraghCountry(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const updateValue = response.data.Value.map((data) => {
          return {
            ...data,
            title: data.Name,
            value: data.Id,
          };
        });
        dispatch({
          type: SAVE_YARAGH_COUNTRY,
          yaraghCountry: updateValue,
        });
        return updateValue;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllBazsho = (params, index = -1) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getAllBazsho(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const bazshoList = response.data.Value;
        const update = bazshoList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_BAZSHO_LIST,
          bazshoList: update,
        });
        dispatch({
          type: SELECT_BAZSHO,
          selectedBazsho: index === -1 ? update.length > 0 ? update[0] : null : update[index],
        });
        return bazshoList;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const setNameForSearchBazshoYaragh = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SEARCHPOP,
      data
    });
  };
};

export const getMahdoode = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getMahdoode(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const mahdode = analyzePrice(response.data.Value.ListRange);
        const isWidth = response.data.Value.IsW;
        const isHeight = response.data.Value.IsH;
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const update = mahdode.map((m, index) => {
          return {
            ...m,
            num: ((page - 1 ) * limit) + index + 1,
            mahdodeArz: m.MinWidth + "-" + m.MaxWidth,
            mahdodeErtefa: m.MinHeight + "-" + m.MaxHeight,
            IdPop: params.IdPop,
            isWidth,
            isHeight,
          };
        });

        dispatch({
          type: SAVE_MAHDOODE_DATA,
          mahdoodeData: update,
          mahdoodeDataPagination: response.data.Pagination,
          isWidth: isWidth,
          isHeight: isHeight,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getHalat = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getHalat(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const halatList = response.data.Value;
        const update = halatList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_HALAT_LIST,
          halatList: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const addyaragh = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.addyaragh(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Hardware_brand_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const addBazsho = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.addBazsho(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Opener_successfully_added'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertAutoBrandYaragh = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.InsertAutoBrandYaragh(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Brand_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const UpdateBrandName = (data) => {
  return async () => {
    try {
      const response = await YaraghService.UpdateBrandName(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteBrandYaragh = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.DeleteBrand(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Hardware_has_been_cleared_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationBrand(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationBrand = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getRelationBrand(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_BRAND_YARAGH_RELATION,
          dataRelationBrand: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const updatePriceBrandGroup = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.updatePriceBrandGroup(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableYaragh = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.disableYaragh(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const DeleteBazshoYaragh = (data, selectedBrandYaraghID) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.DeleteBazsho(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_popup_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationBazsho(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationBazsho = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getRelationBazsho(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const typeRelation = response.data.Value.List;
        const update = typeRelation.map((m, index) => {
          return {
            ...m,
            index: index + 1,
          };
        });
        dispatch({
          type: ACTION_GET_BAZSHO_YARAGH_RELATION,
          dataRelationBazsho: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editBazshoName = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.editBazshoName(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('successfullyEditBazshoFitting'),
          customClass: "success"
        });
        return true;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const DeleteMahdoode = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.DeleteMahdoode(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Range_Cleared_Successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const updateMahdoode = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.updateMahdoode(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Editing_the_hardware_range_was_successful'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const addMahdoode = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.addMahdoode(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('New_range_successfully_added'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const UpdatePriceMahdoode = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.UpdatePriceMahdoode(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('changePriceSuccess'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeMahdoodeSearch = (mahdoodeDataSearch) => (dispatch) => {
  dispatch({
    type: MAHDOODE_SEARCH,
    mahdoodeDataSearch: mahdoodeDataSearch,
  });
};

export const getMahdoodeFani = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getMahdoodeFani(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const mahdode = response.data.Value.ListRange;
        const isWidth = response.data.Value.IsW;
        const isHeight = response.data.Value.IsH;
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const update = mahdode.map((item, index) => {
          return {
            ...item,
            num: ((page - 1 ) * limit) + index + 1,
            width: `${item.MinWidth}-${item.MaxWidth}`,
            height: `${item.MinHeight}-${item.MaxHeight}`,
            IdPop: params.IdPop,
            isWidth,
            isHeight,
          };
        })
        dispatch({
          type: SAVE_MAHDOODEFANI_DATA,
          mahdoodeFani: update,
          mahdoodeFaniPagination: response.data.Pagination,
          isWidthFani: isWidth,
          isHeightFani: isHeight,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getMahdoodeFaniCopy = (params) => {
  return async () => {
    try {
      const response = await YaraghService.getMahdoodeFani(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return {
          list: response.data.Value.ListRange,
          pagination: response.data.Pagination,
        };
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const addMahdoodeFani = (data) => {
  return async () => {
    try {
      const response = await YaraghService.addMahdoodeFani(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('New_range_successfully_added'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const updateMahdoodeFani = (data) => {
  return async () => {
    try {
      const response = await YaraghService.updateMahdoodeFani(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Editing_the_hardware_range_was_successful'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const deleteMahdoodeFani = (data) => {
  return async () => {
    try {
      const response = await YaraghService.deleteMahdoodeFani(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Range_Cleared_Successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getPartLocal = (params) => {
  return async () => {
    try {
      const response = await YaraghService.getPartLocal(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return {
          list: response.data.Value,
          pagination: response.data.Pagination,
        };
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const addPartLocal = (data) => {
  return async () => {
    try {
      const response = await YaraghService.addPartLocal(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('add_new_stuff'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const updatePartLocal = (params) => {
  return async () => {
    try {
      const response = await YaraghService.updatePartLocal(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return true;
      }
      else return false;
    } catch (e) {
      return false;
    }
  };
};

export const deletePartLocal = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.deletePartLocal(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('remove_stuff'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const copyPartLocal = (data) => {
  return async () => {
    try {
      const response = await YaraghService.copyPartLocal(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('copy_product_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const getAxFitting = () => {
  return async () => {
    try {
      const response = await YaraghService.getAxFitting({
        KeyGroup: read("groupKey"), KeyUser: read("userKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value.map(item => {
          return { ...item, label: item.Name, value: item.Id, }
        });
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const getDirectionFitting = () => {
  return async () => {
    try {
      const response = await YaraghService.getDirectionFitting({
        KeyGroup: read("groupKey"), KeyUser: read("userKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value.map(item => {
          return { ...item, label: item.Name, value: item.Id, }
        });
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const getColorFitting = () => {
  return async () => {
    try {
      const response = await YaraghService.getColorFitting({
        KeyGroup: read("groupKey"), KeyUser: read("userKey"),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value.map(item => {
          return { ...item, label: item.Name, value: item.Id, }
        });
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const getStuffFittingCombo = (params) => {
  return async () => {
    try {
      const response = await YaraghService.getStuffFittingCombo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value.map(item => {
          return { ...item, label: item.Name, value: item.Id, }
        });
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const getStuffFitting = (params) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.getStuffFitting(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({ type: SAVENEWSTUFF_ROK });
        return {
          list: response.data.Value,
          pagination: response.data.Pagination,
        };
      } else return false;
    } catch (e) {
      return false;
    }
  };
};

export const addStuffFitting = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.addStuffFitting(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({ type: SAVENEWSTUFF });
        showNotify({
          text: translatorf('New_range_successfully_added'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const updateStuffFitting = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.updateStuffFitting(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({ type: SAVENEWSTUFF });
        showNotify({
          text: translatorf('Editing_the_hardware_range_was_successful'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

export const deleteStuffFitting = (data) => {
  return async (dispatch) => {
    try {
      const response = await YaraghService.deleteStuffFitting(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({ type: SAVENEWSTUFF });
        showNotify({
          text: translatorf('Range_Cleared_Successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};